module.exports = __webpack_public_path__ + "static/media/HealthInsurance.87791c0f.svg";